

























































































































































































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Page, Pageable, SelectOptionDef } from "@/model/component.model";
import {
  AddressDTO,
  AddressLocatorDto,
  MbeServiceDTO,
  SubcountryDTO,
  ZipRegistryEntryDto
} from "@/model/data.model";
import { ShipmentService } from "@/services/ShipmentService";
import DecimalNumber from "@/components/shared/DecimalNumber.vue";
import Modal from "@components/shared/modal/Modal.vue";
import { isCroatia, isPoland, notifyErrorReason } from "@/services/Helpers";
import { required, requiredIf } from "vuelidate/lib/validators";
import isPhone from "@/definitions/telephone-validator";
import SearchPagination from "@/components/shared/SearchPagination.vue";
import { emailValidator } from "@/definitions/email-validator";
import { truncate } from "lodash";

@Component({
  components: {
    DecimalNumber,
    MbeModal: Modal,
    SearchPagination
  },
  validations() {
    const self = this as any;
    return {
      shipmentAddressToValidate: {
        companyName: { required },
        address: {
          required: requiredIf(function() {
            return !self.isAccessPointForm;
          })
        },
        city: {
          required: requiredIf(function() {
            return !self.isAccessPointForm;
          })
        },
        countryName: {
          required: requiredIf(function() {
            return !self.isAccessPointForm;
          })
        },
        countryId: {
          required: requiredIf(function() {
            return !self.isAccessPointForm;
          })
        },
        contact: {
          required: requiredIf(function() {
            return isPoland() || (isCroatia() && self.isHPCourier);
          }),
          validateContact(value: any) {
            return true;
          }
        },
        phone: {
          required: requiredIf(function() {
            return isPoland() || (isCroatia() && self.isHPCourier);
          }),
          validatePhone(value: any) {
            return isPhone(value);
          }
        },
        secondPhone: { isPhone },
        email: {
          required: requiredIf(function() {
            return isPoland();
          }),
          emailValidator
        },
        secondEmail: { emailValidator },
        referenceToContact: {
          required: requiredIf(function() {
            return false;
          }),
          function(value: any) {
            if (value && value.length < 3) {
              return false;
            }
            return true;
          }
        },
        subcountryId: {
          required: requiredIf(function() {
            return !self.isAccessPointForm;
          })
        },
        subcountry: {
          required: requiredIf(function() {
            return !self.isAccessPointForm && !self.isAddressFor;
          })
        }
      }
    };
  }
})
export default class ShipmentAccessPoints extends Vue {
  @Prop({})
  allSubCountries: SubcountryDTO[];
  @Prop({})
  modifyingShipment: boolean;
  @Prop({})
  courierName: string;
  @Prop({})
  courierId: number;
  @Prop({})
  courierServiceId: number;
  @Prop({})
  shipmentType: string;
  @Prop({})
  countryValues: SelectOptionDef[];
  @Prop({})
  showAccessPointsModal: boolean;
  @Prop({})
  eventBus: any;
  @Prop({})
  showAccessPointsInfos: boolean;
  @Prop({})
  receiverAddress: AddressDTO;
  @Prop({})
  receiverSelectedCountry: SelectOptionDef;
  @Prop({ type: Boolean, default: false })
  deliveryPointExportAllowedInHub: boolean;

  _zipCode = "";
  _address = "";

  countriesFiltered: any[] = [];
  accessPointAddress: AddressLocatorDto;
  selectZipRegistry: ZipRegistryEntryDto = {} as ZipRegistryEntryDto;
  zipRegistryLocations: ZipRegistryEntryDto[] = [];
  showZipRegistryLocationModal = false;
  selectedAccessPointCountry: SelectOptionDef = {
    label: " ",
    value: "",
    labelTranslated: ""
  } as SelectOptionDef;
  allRetrievedAccessPoints: any[] = [];
  accessPointsServiceData: MbeServiceDTO;
  searchAddress: any = {
    searchDistance: 8,
    address: "",
    city: "",
    province: "",
    zipCode: "",
    countryId: "",
    countryName: "",
    flavour: "NONE",
    ltz: false
  };
  searchCountry: SelectOptionDef = {
    label: " ",
    value: "",
    labelTranslated: ""
  } as SelectOptionDef;
  pageSize = 50;
  pageInfo = {
    number: 0,
    size: this.pageSize,
    numberOfElements: 0,
    totalElements: 0,
    totalPages: 0
  } as Page;
  pageNumber = 1;
  searchDone = false;

  isMailBoxAccessPoint(locatorName: string) {
    return locatorName.includes("MAIL BOXES ETC");
  }

  get addressType() {
    return "accessPointSearch";
  }

  get shipmentAddressToValidate() {
    return this.searchAddress;
  }

  get isAccessPointForm() {
    return (
      this.addressType === "accessPoint" ||
      this.addressType === "accessPointSearch"
    );
  }

  get isHPCourier() {
    return this.courierName === "HP";
  }

  get disableFetchAccessPointsButton() {
    return this.searchAddress.city === "" || this.searchCountry.value === "";
  }

  get locationSelected() {
    if (this.selectZipRegistry.id === undefined) {
      return false;
    }
    return (
      this.selectZipRegistry.id.townName === this.searchAddress.city &&
      this.selectZipRegistry.id.province === this.searchAddress.province &&
      this.searchAddress.zipCode >= this.selectZipRegistry.id.postcodeFrom &&
      this.searchAddress.zipCode <= this.selectZipRegistry.id.postcodeUntil
    );
  }

  @Watch("shipmentAddressToValidate", { deep: true })
  watchValidation() {
    if (this.$v && this.$v.shipmentAddressToValidate !== undefined) {
      this.$emit(
        "validateAddress",
        this.addressType,
        !this.$v.shipmentAddressToValidate.$invalid
      );
    }
  }

  updateAddress() {
    this.searchAddress.address = this._address;
  }

  checkNumber(field: any) {
    if (field.target.value > 100) {
      this.searchAddress.searchDistance = 100;
    } else if (field.target.value < 8) {
      this.searchAddress.searchDistance = 8;
    } else {
      this.searchAddress.searchDistance = field.target.value;
    }
  }

  selectLocation(location: ZipRegistryEntryDto) {
    this.searchAddress.countryId = location.id.country;
    this.searchAddress.province = location.id.province;
    this.searchAddress.city = location.id.townName;

    const currentZipCode = this.searchAddress.zipCode;
    if (currentZipCode !== "") {
      if (
        currentZipCode >= location.id.postcodeFrom &&
        currentZipCode <= location.id.postcodeUntil
      ) {
        this.searchAddress.zipCode = currentZipCode;
      }
    } else {
      this.searchAddress.zipCode = location.id.postcodeFrom;
    }
    this.selectZipRegistry = location;
  }

  toggleShowZipRegistryLocationModal() {
    this.showZipRegistryLocationModal = !this.showZipRegistryLocationModal;
  }

  updateCountry(value: SelectOptionDef, subcountryValue?: any) {
    if (this.showAccessPointsModal) {
      if (!this.deliveryPointExportAllowedInHub) return;
      if (this.searchCountry.value != value.value) this.searchCountry = value;
      this.searchAddress.countryName = this.searchCountry.label;
      this.searchAddress.countryId = String(this.searchCountry.value);
      if (value.value === "IT") {
        this.searchAddress.province = this.searchAddress.province
          ? this.searchAddress.province.toUpperCase()
          : this.searchAddress.province;
      }
    } else {
      if (this.modifyingShipment) return;
      if (this.selectedAccessPointCountry.value != value.value)
        this.selectedAccessPointCountry = value;

      this.accessPointAddress.countryId = String(
        this.selectedAccessPointCountry.value
      );
      if (value.value === "IT") {
        this.accessPointAddress.province = this.accessPointAddress.province
          ? this.accessPointAddress.province.toUpperCase()
          : this.accessPointAddress.province;
      }
    }
  }

  resetCountriesFiltered() {
    setTimeout(() => {
      this.countriesFiltered = this.countryValues;
    }, 100);
  }

  clearFields(value: string) {
    this.selectZipRegistry = {} as ZipRegistryEntryDto;
    this.resetSearchForm(value);
  }

  executeSearchZipRegistryLocation() {
    this.pageInfo.number = this.pageNumber - 1;
    this.pageInfo.size = this.pageSize;
    this.searchZipRegistryLocation();
  }

  searchZipRegistryLocation(tabKey?: boolean) {
    if ((tabKey && this.addressType !== "accessPointSearch") || !tabKey) {
      this.searchAddress.zipCode = this._zipCode;
      this.selectZipRegistry = {} as ZipRegistryEntryDto;
      if (
        this.searchAddress &&
        (!this.searchAddress.countryId || this.searchAddress.countryId == "")
      ) {
        return;
      }
      ShipmentService.prototype
        .getAccessPointZipRegistry({
          country: this.searchAddress.countryId,
          zipcode: this.searchAddress.zipCode,
          province: this.searchAddress.province,
          city: this.searchAddress.city,
          page: this.pageInfo.number,
          size: this.pageInfo.size
        })
        .then((res: any) => {
          const data = res.data as Pageable<ZipRegistryEntryDto>;
          if (data) {
            if (data.content.length == 1) {
              this.selectLocation(data.content[0]);
            } else {
              if (data.content.length > 0) {
                this.zipRegistryLocations = data.content;
                this.showZipRegistryLocationModal = true;
                this.pageInfo.totalElements = data.totalElements;
                this.pageInfo.totalPages = data.totalPages;
                this.pageInfo.size = data.size;
                this.pageInfo.numberOfElements = data.numberOfElements;
                this.pageInfo.number = data.number;
              } else {
                if (this.searchAddress.province || this.searchAddress.city) {
                  this.searchAddress.province = "";
                  this.searchAddress.city = "";
                  this.searchZipRegistryLocation();
                } else {
                  this.$notify.error(String(this.$t("no_location_found")));
                }
              }
            }
          }
        })
        .catch(err => {
          this.$emit("input", 0);
          return notifyErrorReason(err, this);
        });
    }
  }

  created() {
    this.eventBus.$on("serviceSelected", (data: any) => {
      if (data.idMBEBusiness !== 11) {
        this.resetAccessPointForm();
      } else {
        this.accessPointsServiceData = data;
      }
    });
  }

  updateShipmentAddressData(event: any, getShipmentDetails?: boolean) {
    const input = event.target;
    const name = input.name;
    let value = input.type === "checkbox" ? input.checked : input.value.trim();

    if (name === "flavour") {
      value = input.value;
      if (value === this.searchAddress.flavour) {
        value = "NONE";
      }
    }

    if (
      (this.courierName === "UPS" && name === "province") ||
      (this.searchCountry.value === "IT" && name === "province")
    ) {
      value = value.toUpperCase();
    }

    if (name === "address") {
      this.searchAddress.address = value;
    }
  }

  updateZipCode() {
    this.searchAddress.zipCode = this._zipCode;
  }

  getAvailableAccessPoints() {
    const address = {
      address: this.searchAddress.address,
      city: this.searchAddress.city,
      province: this.searchAddress.province,
      zipCode: this.searchAddress.zipCode,
      countryId: this.searchAddress.countryId,
      distance:
        this.searchAddress.searchDistance !== ""
          ? +this.searchAddress.searchDistance
          : ""
    };
    ShipmentService.prototype
      .getAvailableAccessPoints(
        address,
        this.shipmentType,
        this.courierServiceId,
        this.courierId,
        this.courierName
      )
      .then((res: any[]) => {
        this.allRetrievedAccessPoints = res;
        this.searchDone = true;
      })
      .catch(err => {
        this.allRetrievedAccessPoints = [];
      });
  }

  closeAccessPointsModal() {
    this.searchDone = false;
    this.$emit("closeModal");
  }

  async selectAccessPoint(item: AddressLocatorDto) {
    let address = item.address;
    let secondAddress = "";
    let thirdAddress = "";
    const maxLength = 35;
    if (address.length > maxLength) {
      const firstAddress = truncate(address, {
        length: maxLength,
        separator: " ",
        omission: " "
      });
      secondAddress = truncate(address.substring(firstAddress.length), {
        length: maxLength,
        separator: " ",
        omission: " "
      });
      thirdAddress = truncate(
        address.substring(firstAddress.length + secondAddress.length),
        { length: maxLength, separator: " ", omission: " " }
      );
      address = firstAddress;
    }
    this.accessPointAddress = {
      ...item,
      address,
      secondAddress,
      thirdAddress,
      companyName: item.locatorName
    };

    this.selectedAccessPointCountry = this.countryValues.find(
      country => country.value === item.countryId
    );
    if (this.selectedAccessPointCountry.value === "IT") {
      let zipRegistryList = await ShipmentService.prototype.getAccessPointZipRegistry(
        {
          country: this.accessPointAddress.countryId,
          zipcode: this.accessPointAddress.zipCode
        }
      );
      let list = zipRegistryList.data.content as ZipRegistryEntryDto[];
      if (!list.length || list.length > 1) {
        zipRegistryList = await ShipmentService.prototype.getAccessPointZipRegistry(
          {
            country: this.accessPointAddress.countryId,
            zipcode: this.accessPointAddress.zipCode,
            city: this.accessPointAddress.city
          }
        );
        list = zipRegistryList.data.content as ZipRegistryEntryDto[];
      }
      if (list.length === 1) {
        this.accessPointAddress.province = list[0].id.province;
      }
    }
    this.$emit("accessPointSelected", this.accessPointAddress);
    this.closeAccessPointsModal();
  }

  executeAccessPointsSearch() {
    this.pageInfo.number = this.pageNumber - 1;
    this.pageInfo.size = this.pageSize;
  }

  @Watch("courierName", {})
  updateAccessPointForm() {
    if (this.courierName !== "UPS") {
      this.resetAccessPointForm();
    }
  }

  resetAccessPointForm() {
    this.accessPointAddress = {} as AddressLocatorDto;
    this.selectedAccessPointCountry = {
      label: " ",
      value: "",
      labelTranslated: ""
    } as SelectOptionDef;
  }

  resetSearchForm(field: string) {
    if (field === "accessPointSearch") {
      this.searchAddress.address = "";
      this.searchAddress.city = "";
      this.searchAddress.province = "";
      this.searchAddress.zipCode = "";
      this.searchAddress.searchDistance = "";
    }
  }

  // fill search fields with receiver respective values
  @Watch("showAccessPointsModal")
  prefillSearchFields() {
    this.searchAddress.zipCode = this.receiverAddress.zipCode
      ? this.receiverAddress.zipCode
      : "";
    this._zipCode = this.searchAddress.zipCode;
    this.searchAddress.city = this.receiverAddress.city
      ? this.receiverAddress.city
      : "";
    this.searchAddress.countryId = this.receiverAddress.countryId
      ? this.receiverAddress.countryId
      : "";
    this.searchAddress.province = this.receiverAddress.province
      ? this.receiverAddress.province
      : "";
    this.searchAddress.address = this.receiverAddress.address
      ? this.receiverAddress.address
      : "";
    this._address = this.searchAddress.address;
    this.searchCountry = this.receiverSelectedCountry;
    this.allRetrievedAccessPoints = [];
    if (this.showAccessPointsModal && this.searchAddress.city != "") {
      this.getAvailableAccessPoints();
    }
  }
}
